import script from "./FeedbackInputWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackInputWrapper.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackInputWrapper.vue?vue&type=style&index=0&id=1386eb2f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1386eb2f"]])

export default __exports__